<template>
  <section class="tw-page ai-home-page">
    <div class="tw-container">
      <PageHeader
        title="Insight Workspace"
        subtitle="Explore your team, clients, delivery risk, and operating opportunities."
      />

      <div v-if="isLoading" class="tw-state">
        <b-loading :is-full-page="false" :active="true" />
        <p>Loading your profile...</p>
      </div>

      <AIAssistant
        v-else
        :is-manager="user?.isManager === true"
        :is-admin="user?.isAdmin === true"
        :selected-client-name="selectedClientName"
        :selected-team-member-name="selectedTeamMemberName"
        :auto-run-action-id="autoRunActionId"
        :initial-ticket-nbr="initialTicketNbr"
      />
    </div>
  </section>
</template>

<script>
import { useUserStore } from '@/stores/userStore'
import { mapState } from 'pinia'
import PageHeader from '@/components/layout/PageHeader.vue'
import AIAssistant from '@/components/roster/AIAssistant.vue'

export default {
  name: 'AIAssistantHome',
  components: {
    PageHeader,
    AIAssistant,
  },
  props: {
    autoRunActionId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(useUserStore, ['user', 'loading']),
    isLoading() {
      return this.loading || this.user === null
    },
    selectedClientName() {
      return String(this.$route?.query?.client || this.$route?.query?.clientName || '').trim()
    },
    selectedTeamMemberName() {
      return String(
        this.$route?.query?.teamMember ||
        this.$route?.query?.teamMemberName ||
        this.$route?.query?.member ||
        '',
      ).trim()
    },
    initialTicketNbr() {
      const value = String(this.$route?.query?.ticket || '').trim()
      return /^\d+$/.test(value) ? value : ''
    },
  },
  created() {
    const userStore = useUserStore()
    const token = this.$cookies.get('teamwrkr-token')
    if (token && !this.user?._id) {
      userStore.fetchUser(token)
    }
  },
}
</script>
